import { Symbol }  from '@cfa/brand-icons/logos';
import tokens from "@cfa/design-tokens";

export const LogoIcon = () => {
  return (
    <Symbol size="sm" color="brand-red" style={{ fill: tokens.color.primary.base.modes.light }}/>
  );
};